
    <div *ngIf="!noConfigurationFound">
        <h1>{{'MFA_REQUIRED.MFA_HEADER' | translate}}</h1>
        <p>{{'MFA_REQUIRED.CONFIRM_IDENTITY' | translate}}</p>
      <ng-container *cidContentLoader="contentLoading">
        <div *ngIf="showMFAList">
            <div *ngIf="displayMFAList.length > 0">
                <ul fxLayout="column" fxLayout.xs="column" fxLayoutGap="0.5rem" class="mfa-list">
                    <li (click)="chooseVerificationType(item, multipleDeviceList)" *ngFor="let item of displayMFAList">
                        <div>
                            <div fxLayoutAlign="center center" fxFlex="20" fxFlex.xs="40">
                                <span class="mfa-icon mfa-icon-list"
                                    [ngClass]="'cidaas-icon-'+item.type.toLowerCase()"></span>
                            </div>
                            <div class="mfa-desc" fxFlex="80" fxFlex.xs="60">
                                <h3 class="mfa-title">
                                    {{'MFA_REQUIRED.' + item.type | translate}}
                                </h3>
                                <p fxHide.xs>
                                    {{'MFA_REQUIRED.' + item.type + '_DESC' | translate}}
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div *ngIf=listErrorMessage class="mat-error">
                {{listErrorMessage | translate}}
            </div>
            <div class="section">
                <a (click)="commonFunc.getRedirectedByRequestId()">{{'BACK' | translate}}</a>
            </div>
        </div>

        <div *ngIf="!showMFAList">
            <div class="mfa-icon-holder" fxLayoutAlign="center center">
                <div [class.circle-ripple]="showWaitingSymbol">
                    <span class="mfa-icon" [ngClass]="'cidaas-icon-' + mfaTypeSelected.toLowerCase()"></span>
                </div>
            </div>

            <div *ngIf="showInputField">
                <app-input (keydown.enter)="verifyAuth()" (valueEmit)="setCode($event)"
                    [option]="mfaTypeSelected === 'PASSWORD' ? passwordGroupOption : inputGroupOption"></app-input>
            </div>


            <p>{{'MFA_REQUIRED.' + 'VERIFY_' + mfaTypeSelected | translate}}</p>
            <div fxLayoutAlign="center center" *ngIf="pushSelectedNumber">
                <div class="push-notification-number">
                    {{pushSelectedNumber}}
                </div>
            </div>

            <div *ngIf=errorMessage class="mat-error">
                {{errorMessage | translate}}
            </div>

            <div class="section btn-group">
                <a (click)="cancelAuth()">{{'CANCEL' | translate}}</a>
                <app-button  (clickEvent)="verifyAuth()" [btnOption]="buttonOptions.verify"
                    *ngIf="isVerifyButtonRequired()"
                    [loading]="verifyingInProgress"
                >
                </app-button>
            </div>
        </div>

      </ng-container>
    </div>


    <div *ngIf="noConfigurationFound">
        <div class="section">
            <h1>{{'MFA_REQUIRED.NO_MFA_CONFIGURED' | translate}}</h1>
            <p>
                {{'MFA_REQUIRED.NEED_TO_CONFIGURE_MFA' | translate}}
            </p>
            <a (click)="commonFunc.getRedirectedByRequestId()">{{'BACK' | translate}}</a>
        </div>
    </div>


<ng-template #multipleDeviceList>
    <mat-dialog-content>
        <table mat-table [dataSource]="mediumList" class="mat-elevation-z8">

            <!-- Medium ID Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> Medium Id </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <!-- Medium Name Column -->
            <ng-container matColumnDef="key_name">
                <th mat-header-cell *matHeaderCellDef> Medium Name </th>
                <td mat-cell *matCellDef="let element"> {{element.key_name}} </td>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="notification">
                <th mat-header-cell *matHeaderCellDef> Send Notification </th>
                <td class="text-center cursor-pointer" mat-cell *matCellDef="let element"
                    (click)="selectDevice(element)">
                    <mat-icon>send_to_mobile</mat-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </mat-dialog-content>
</ng-template>
